import { Input, Form, Button, Link, SectionTitle } from 'src/components'
import { loginType, loginZodSchema } from 'src/types'
import { Logo, Right } from 'src/assets'
import { ROUTE_HOME } from 'src/lib'
import { t } from 'i18next'

const LoginPage = () => {
  const handleSubmit = (data: loginType) => {
    console.log(data, 'todo add functionality when BE is ready')
  }

  return (
    <div className='w-full h-full flex-column justify-center items-center gap-[30px] bg-light-gray p-[50px]'>
      <Link to={ROUTE_HOME}>
        <Logo className='w-[80px] h-[80px]' />
      </Link>
      <div className='p-[40px] bg-mid w-[400px] rounded-sm transition-all duration-500 hover:scale-105 bg-white'>
        <SectionTitle
          title={t('login.welcome.tittle')}
          subtitle={t('login.welcome.subtitle')}
          textPosition='left'
        />
        <Form
          className='gap-[20px] flex-column'
          onSubmit={handleSubmit}
          schema={loginZodSchema}
        >
          <Input name='username' label={t('global.username')} />
          <Input name='password' type='password' label={t('global.password')} />
          <Button type='submit' size='m' icon={<Right />}>
            {t('global.login')}
          </Button>
          <div className='flex-center w-full'>
            <Link size='small' to='/forgot-password'>
              {t('global.forget.password')}?
            </Link>
          </div>
        </Form>
      </div>
      <div className='flex gap-[10px] text-dark-gray base-normal'>
        {t('login.no.have.account')}
        <Link className='text-black' to='/register'>
          {t('global.register.now')}
        </Link>
      </div>
    </div>
  )
}

export default LoginPage
